angular.module('impactx.controlChip').controller('CreateControlPanelCtrl', [
    '$scope',
    'locals',
    'dataGen',
    'ToastService',
    'mdPanelRef',
    'TranslationService',
    'themeFactory',
    CreateControlPanelCtrlCtrl]);

function CreateControlPanelCtrlCtrl($scope, locals, dataGen, ToastService, mdPanelRef, TranslationService, themeFactory) {
    var self = this;
    $scope.trns = locals.trns;
    $scope.isASN = locals.type.toLowerCase().indexOf('asn') >= 0;
    $scope.theme = themeFactory.getTheme();

    $scope.name = undefined;
    $scope.number = undefined;
    self.subNumber = undefined;

    function determineControlType() {
        var controlType = "";
        if (locals.type.toUpperCase().indexOf('SUP') >= 0) {
            controlType = locals.type.substring(3, locals.type.length);
        }
        else if (locals.type.toUpperCase().indexOf('ITEM') >= 0) {
            controlType = locals.type.substring(4, locals.type.length);
        }
        else {
            controlType = locals.type;
        }
        if(controlType.toUpperCase().indexOf('CTRL') >= 0) {
            controlType = controlType.substring(0, 5);
        } else {
            controlType = controlType.substring(0, 3);
        }

        return controlType;
    }

    $scope.saveControlStruct = function () {
        var params = {
            name: $scope.name,
            number: $scope.number,
            subNumber: self.subNumber,
            type: determineControlType()
        };
        dataGen.postAsForm($scope, params, "/basket/control/new", false, false, true).then(function (data) {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $scope.name = undefined;
            $scope.number = undefined;
            self.subNumber = undefined;
            mdPanelRef && mdPanelRef.close(data.data.newControl);
        }, function (data) {
            if (data.errors) {
                $scope.$applyAsync(function () {
                    $scope.controlError = data.errors[0].error;
                    $scope.controlPanelForm.number.$setValidity("controlError", false);
                });
            }
        });
    }
}
